import { AfterViewInit, Directive, ElementRef, HostListener, Input } from '@angular/core';

/**
 * Directive which moves the element down when the window is scrolled
 * vertically to archive a parallax-like scrolling.
 */
@Directive({
  selector: '[mbParallax]',
})
export class ParallaxDirective implements AfterViewInit {
  // optional speed of parallax scrolling, use negative numbers to scroll
  // in up and positive numbers to scroll down
  @Input()
  parallaxSpeed = 0.3;

  // add native window scroll listener which moves the element up / down
  // depending on the vertical scrolling position
  @HostListener('window:scroll')
  onScroll() {
    const scrollTop = window.pageYOffset;
    // when the element is not at the beginning of the page the offsetTop must
    // be substracted from the scrollTop position otherwise the element would
    // move out of the visible bounds
    const offsetTop = this.el.nativeElement.offsetTop;
    const y = (scrollTop - offsetTop) * this.parallaxSpeed;
    // set the top position of the element using matrix transform which is
    // a bit faster in some browsers
    this.el.nativeElement.style.transform = 'matrix(1, 0, 0, 1, 0, ' + y + ')';
  }

  public constructor(private el: ElementRef) {}

  public ngAfterViewInit() {
    // intially set the element to "block" style otherwise the transform
    // would not apply
    if (!this.el.nativeElement.style.display) {
      this.el.nativeElement.style.display = 'block';
    }
    // apply overflow:hidden on the parent element, otherwise the element
    // would be visible out of the parent’s bounds
    this.el.nativeElement.parentElement.style.overflow = 'hidden';
  }
}
